import { WorkItemViewInfo } from 'runtime/data/workitemviewinfo';

export class RuntimeHostRequested {
    static eventName() { return 'RuntimeHostRequested' }
    eventName = RuntimeHostRequested.eventName;
    constructor(public wivi: WorkItemViewInfo) { }
}